import { Title } from '../../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-Up</Title>

                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial S/C;</li>
                            <li>Coronal S/C;</li>
                            <li>Sagital S/C</li>
                            <li>Axial C/C Trifásico</li>
                            <li>Coronal C/C Fase Cortical;</li>
                            <li>Sagital C/C Fase Cortical;</li>
                            <li>Coronal C/C Fase Medular;</li>
                            <li>Sagital C/C Fase Medular;</li>
                            <li>Coronal C/C Fase Excretora;</li>
                            <li>Sagital C/C Fase Excretora;</li>
                            <li>3D VR - URO Dir. / Esq.;</li>
                            <li>3D VR - URO Sup. / Inf.;</li>
                            <li>3D MIP - URO Dir. / Esq.;</li>
                            <li>3D MIP - URO Sup. / Inf.;</li>
                            <li>Reformatações curvas;</li>
                            <li>Relatório de dose;</li>
                        </ul>
                    </section>
                </div>
            </div>
        </Container>
    )
}